<template>
  <div class="content">
    <div class="content-box">
      <div class="search">
        <div class="left">
          <div style="margin-right: 10px;"><span>车库名称 
            <el-input v-model="serchName" @input="watchInput"  clearable size="small" placeholder="请输入车库名称" style="width: 200px"></el-input>
            </span></div>
          <span class="button" @click="doFilter">查询</span>
        </div>
        <div class="right">
           <!-- v-if="isMenuExit('pro:garage:import')" -->
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHead"
            :show-file-list="false"
            :on-success="handleAppSuccess"
            :data="uploadData"
          >
          <span class="button">导入</span>
          </el-upload>
          <span class="button" @click="exportInfo" style="margin: 0 10px">导出</span>
          <!-- v-if="isMenuExit('pro:garage:add')" -->
          <span class="button"  @click="add()">添加</span>
        </div>
      </div>
       <el-table
          stripe
          :data="tableData"
          height="76vh"
          style="width: 100%;"
          :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="编号">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="车库名称">
            <template slot-scope="scope">
              <span>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="自有车位">
            <template slot-scope="scope">
              <span>{{scope.row.carportCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="已售车位">
            <template slot-scope="scope">
              <span>{{scope.row.elementCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前车位车辆数">
            <template slot-scope="scope">
              <span>{{scope.row.carCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="车库平面图">
            <template slot-scope="scope">
              <!-- <span>{{scope.row.carportPhoto}}</span> -->
              <el-image v-if="scope.row.photo!=''" style="width: 5vh; height: 5vh;cursor: pointer;" :src="scope.row.photo" :preview-src-list="scope.row.srcList"></el-image>
              <img v-else src="../../../assets/image/zanwutupian.png" style="width: 5vh; height: 5vh;cursor: pointer;" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <!-- v-if="isMenuExit('pro:garage:edit')" -->
              <span class="table-button" style="margin-right: 5px;"  @click="edit(scope.row)">修改</span>
              <span class="table-button" v-if="isMenuExit('pro:garage:info')" @click="look( scope.row)">查看</span>
            </template>
          </el-table-column>
        </el-table>
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        >
        </el-pagination>
    </div>
     <!-- 添加弹出框 -->
      <el-dialog
        :title="diaTitle"
        :visible.sync="editFormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        width="30%"
      >
        <div slot="title" class="dialog-title">{{diaTitle}}</div>
        <el-form
          :model="editForm"
          ref="editForm"
          label-width="100px"
          label-position="right"
          class="teamPage"
          :rules="teamRules"
        >
          <el-form-item label="车库名称：" prop="name">
            <el-input v-model="editForm.name" autocomplete="off" style="width:220px"></el-input>
          </el-form-item>
            <el-form-item label="车位图：">
            <el-upload
              class="avatar-uploader"
              v-bind:action="uploadUrl1"
              :headers="uploadHead1"
              :data="{type:223}"
              :show-file-list="false"
              :on-success="handleIconSuccess"
            >
              <img style="width: 100%" v-if="icon" :src="icon" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitAddRow('editForm')" style="background: #4D6EB1">确 定</el-button>
        </div>
      </el-dialog>
        <!-- 导出成功弹出框 -->
      <el-dialog
        :title="dialogTitle1"
        :visible.sync="imoportVisible"
        center
        :append-to-body="true"
        :before-close="handleClose1"
        :lock-scroll="false"
        width="30%"
      >
        <template>
          <el-table :data="tableData1" style="width: 100%" border>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status==0">
                  <i class="el-icon-circle-check" style="color:#07C160"></i>
                </span>
                <span v-if="scope.row.status==1">
                  <i class="el-icon-warning-outline" style="color:#f00"></i>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="reason" label="原因">
              <template slot-scope="scope">
                <span v-if="scope.row.status==0" style="color:#07C160">{{scope.row.reason}}</span>
                <span v-if="scope.row.status==1" style="color:#f00">{{scope.row.reason}}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-dialog>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        tableData: [], //获取数据
        tableData1: [],
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        projectId: '',
        serchName: '', //车库名称
        uploadUrl: myHttp.importCarportForExcel, //上传地址
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        uploadData: {
          projectId: '',
          userId: '',
        },
        dataText: '暂无数据',
        uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
        uploadHead1: {
          accessToken: util.session.get('token'),
        },
        editFormVisible: false,
        dialogTitle: '',
        dialogTitle1: '导入',
        editForm: {
          id: '',
          name: '', //车库名
          carportPhoto: '', //车位图片
          // carportPhoto: '', //
        },
        imoportVisible: false,
        icon: '', // 车位停车图
        updateBy: '',
        userId: '',
        diaTitle:'',
        teamRules:{
            name: [
              { required: true, message: '请输入车库名称', trigger: 'change' }
            ],
        }
      }
    },
    mounted() {
      this.projectId = util.session.get('groupId')
      this.userId = util.session.get('user').id
      this.updateBy = util.session.get('user').id
      if (this.projectId == '') {
        this.$store.commit('setGroupId')
        this.projectId = this.$store.state.groupId
      }
      ;(this.uploadData.projectId = this.projectId),
        (this.uploadData.userId = this.userId)
      this.getData()
      // console.log(this.$store.state.token)
    },
    methods: {
      //获取数据
      getData() {
        var that = this
        myHttp
          .secCarportByLikeName({
            projectId: this.projectId,
            name: this.serchName,
            pageSize: this.pageSize,
            pageNum: this.currentPage,
          })
          .then(
            function (resp) {
              if (resp.data.code == '200') {
                var list = resp.data.data.carportInfo.list || []
                for (var i = 0; i < list.length; i++) {
                  list[i].index = that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
                  list[i].photo = list[i].carportPhoto && list[i].carportPhoto!=''?base.httpCtx+list[i].carportPhoto:''
                  list[i].srcList = list[i].photo && list[i].photo!=''?[list[i].photo]:[]
                }
                that.tableData = list
                that.totalItems = resp.data.data.carportInfo.total
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function () {}
          )
      },
      // 将新增的数据添加到表格中
      sumbitAddRow(formName) {
        var that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.editForm.updateBy = this.updateBy
            that.editForm.projectId = this.projectId
            if(this.editForm.id==''){
                myHttp.createInfoCar(that.editForm).then(
                  function (resp) {
                    if (resp.data.code == '200') {
                      that.$message.success('创建车库成功')
                      that.editFormVisible = false
                      that.getData()
                    } else {
                      that.$message.error(resp.data.msg)
                    }
                  },
                  function () {}
                )
            }else{
                  myHttp.updateInfoCar(that.editForm).then(
                  function (resp) {
                    if (resp.data.code == '200') {
                      that.$message.success('修改车库成功')
                      that.editFormVisible = false
                      that.getData()
                    } else {
                      that.$message.error(resp.data.msg)
                    }
                  },
                  function () {}
                )
            }
          }
        })
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
      },
      // 监控当前页码
      currentChangePage(list) {
        this.getData()
      },
      // 编辑弹框
      edit(row) {
        this.dialogTitle = '修改车库'
        this.editFormVisible = true
        this.editForm = {
          name: row.name,
          carportCount: row.carportCount,
          carportPhoto: row.carportPhoto,
          id: row.id,
        }
        this.icon =row.carportPhoto && row.carportPhoto != '' ? base.httpCtx + row.carportPhoto: ''
        console.log(this.icon)
      },
      //添加车库
      add() {
        this.diaTitle='添加车库'
        this.editFormVisible=true
        this.editForm={
          id: '',
          name: '', //车库名
          carportPhoto: '', //车位图片
        }
        this.icon=''
      },
      // 导出
      exportInfo() {
        var token = this.$store.state.token
        window.open(
          myHttp.exportCarportForExcel +
            '?projectId=' +
            this.projectId +
            '&accessToken=' +
            token
        )
      },
      doFilter() {
        this.getData()
      },
      //
      handleChange(e) {
        this.editForm.useType = e.value
        // console.log(e.value)
      },

      //上传成功监听方法
      handleAppSuccess(res, file) {
        if (res.code == '200') {
          this.imoportVisible = true
          this.tableData1 = res.data.list
          this.getData()
        } else {
          this.$message.error(res.msg)
        }
      },
      // 上传图片
      handleIconSuccess(res, file) {
        this.icon = URL.createObjectURL(file.raw)
        this.editForm.carportPhoto = res.data.savePhotoUrls
      },
      // 查询
      search() {
        this.getData()
      },
      // 关闭弹出框弹窗
      handleClose(done) {
        this.editFormVisible = false
      },
      handleClose1(done) {
        this.imoportVisible = false
      },
      // 查看车库信息
      look(row) {
        var id = row.id
        this.$router.push({ name: 'carLower', params: { id: id } })
      },
      watchInput(e){
          this.serchName = e
          this.getData()
      },

      /**
       * 判断是否展示
       */
      isMenuExit(row){
          var flag = util.common.filterBtnMenu(row)
          return flag
      },
    },
  }
</script>

<style scoped>
.button{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.table-button{
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-size: 14px;
  color: #8EA3CE;
  cursor: pointer;
}
.content{
  height: 100%;
  padding: 1vh 1vw;
}
.content-box{
  height: calc(100% - 2vh);
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.search{
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #D8D8D8;
  padding: 12px 18px;
}
.left{
  display: flex;
}
.right{
  display: flex;
}

/deep/ .el-dialog__header{
  padding: 0;
}
.dialog-title{
  padding: 9px 24px;
  height: 40px;
  text-align: left;
  font-size: 16px;
  color: #666666;
  background-color: #ECF0F5;
}
/deep/ .el-dialog__close{
  font-size: 24px;
}
/deep/ .el-dialog__headerbtn{
  top: 10px;
}
</style>